/* LARABICO home: slider hero, menu mobile, header a pillola allo scroll. Senza librerie. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Slider hero ---- */
  function initSlider(root) {
    var slides = root.querySelectorAll('[data-lbh-slide]');
    var dots = root.querySelectorAll('[data-lbh-dot]');
    if (slides.length < 2 || root.__lbhInit) return;
    root.__lbhInit = true;

    var current = 0;
    var timer = null;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;

    function show(i) {
      current = (i + slides.length) % slides.length;
      for (var s = 0; s < slides.length; s++) slides[s].classList.toggle('is-active', s === current);
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === current);
    }
    function start() {
      if (!autoplay || timer) return;
      timer = setInterval(function () { show(current + 1); }, interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    for (var d = 0; d < dots.length; d++) {
      (function (i) {
        dots[i].addEventListener('click', function () { show(i); stop(); start(); });
      })(d);
    }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  }

  /* ---- Menu mobile ---- */
  function initMenu() {
    var drawer = document.getElementById('lbh-drawer');
    if (!drawer || drawer.__lbhInit) return;
    drawer.__lbhInit = true;
    var toggles = document.querySelectorAll('[data-lbh-menu-toggle]');

    function setOpen(open) {
      drawer.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      for (var i = 0; i < toggles.length; i++) toggles[i].setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', function () { setOpen(drawer.hidden); });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) setOpen(false); });
    window.addEventListener('resize', function () { if (window.innerWidth >= 750 && !drawer.hidden) setOpen(false); });
  }

  /* ---- Header a pillola: compare quando la hero esce dallo schermo ---- */
  function initPill() {
    var pill = document.querySelector('[data-lbh-pill]:not(.lbh-pill--always)');
    var hero = document.querySelector('[data-lbh-hero]');
    if (!pill || !hero || pill.__lbhInit) return;
    pill.__lbhInit = true;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        // visibile quando la parte alta della hero (il suo header) è uscita
        var e = entries[0];
        pill.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { rootMargin: '-120px 0px 0px 0px', threshold: 0 });
      io.observe(hero);
    }
  }

  /* ---- Filtri collezione: applica quando cambia un campo ---- */
  function initFacets() {
    var forms = document.querySelectorAll('[data-lbh-facets]');
    for (var i = 0; i < forms.length; i++) {
      (function (f) {
        if (f.__lbhInit) return;
        f.__lbhInit = true;
        f.addEventListener('change', function () { f.submit(); });
      })(forms[i]);
    }
  }


  /* ---- Carrello a cassetto (cart drawer di Dawn) ---- */
  function setCartCount(n) {
    var links = document.querySelectorAll('[data-lbh-cart]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var badge = a.querySelector('.lbh-bar__count');
      if (n > 0) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'lbh-bar__count'; a.appendChild(badge); }
        badge.textContent = n;
        a.setAttribute('aria-label', 'Carrello (' + n + ')');
      } else {
        if (badge) badge.parentNode.removeChild(badge);
        a.setAttribute('aria-label', 'Carrello');
      }
    }
  }
  function initCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__lbhInit) return;
    drawer.__lbhInit = true;
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var onCartPage = window.location.pathname.replace(/\/$/, '') === cartUrl.replace(/\/$/, '');

    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('[data-lbh-cart]') : null;
      if (!link || onCartPage || typeof drawer.open !== 'function') return;
      e.preventDefault();
      // chiude il menu mobile se aperto
      var menu = document.getElementById('lbh-drawer');
      if (menu && !menu.hidden) { menu.hidden = true; document.documentElement.style.overflow = ''; }
      drawer.open(link);
    });

    // Sconti automatici: a volte Shopify li calcola un attimo DOPO l'aggiunta al carrello.
    // Un secondo dopo ogni aggiunta rileggiamo la finestra e la aggiorniamo SOLO se è cambiata
    // (niente lampeggio quando è già giusta).
    function refreshDrawerIfChanged() {
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      fetch(cartUrl + '?section_id=cart-drawer', { cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var html = new DOMParser().parseFromString(text, 'text/html');
          var sels = ['cart-drawer-items', '.cart-drawer__footer'];
          for (var i = 0; i < sels.length; i++) {
            var cur = document.querySelector(sels[i]);
            var upd = html.querySelector(sels[i]);
            if (cur && upd && cur.innerHTML !== upd.innerHTML) cur.innerHTML = upd.innerHTML;
          }
        })
        .catch(function () {});
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'cart-items') return;
        setTimeout(refreshDrawerIfChanged, 1000);
      });
    }

    // il contatore: Dawn aggiorna #cart-icon-bubble dopo ogni modifica, noi lo copiamo sulle nostre icone
    var proxy = document.getElementById('cart-icon-bubble');
    if (proxy && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var span = proxy.querySelector('.cart-count-bubble span[aria-hidden]');
        setCartCount(span ? parseInt(span.textContent, 10) || 0 : 0);
      }).observe(proxy, { childList: true, subtree: true, characterData: true });
    }
  }

  function init() {
    var sliders = document.querySelectorAll('[data-lbh-slider]');
    for (var i = 0; i < sliders.length; i++) initSlider(sliders[i]);
    initMenu();
    initPill();
    initFacets();
    initCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Editor del tema: ricarica i componenti quando una sezione viene rigenerata
  document.addEventListener('shopify:section:load', init);
})();
